<template>
    <div id="claims">

        <h1 class="visually-hidden">Liste des réclamations - PharmaConnect</h1>

        <b-modal size="lg" hide-footer ref="my-modal" title="Nouvelle Réclamation">
            <b-row>
                <b-col cols="12" md="12">
                    <b-form-group>
                        <label style="font-weight:bold">Type : </label>
                        <b-row class="ml-0 mt-1">
                            <b-col cols="6" md="3" v-for="t in types" :key="t" class="mb-1">
                                <b-form-radio v-model="selectedType" name="claim-type" :value="t"
                                    class="custom-control-success mb-0">
                                    {{ t }}
                                </b-form-radio>
                                <small class="text-muted d-block ml-2">{{ typeDescriptions[t] }}</small>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="12">
                    <b-form-group>
                        <label style="font-weight:bold">Message : </label>
                        <b-form-textarea id="textarea-state" ref="description" v-model="recText"
                            :state="recText.length <= 400" placeholder="Ne pas dépasser 400 caractères" rows="3" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="text-right">

                <b-col cols="12" md="12">
                    <b-button @click="reset_data" variant="gradient-warning" style="margin-right:5px">
                        Initialiser
                    </b-button>
                    <b-button @click="envoyer" :disabled="!validateForm" variant="gradient-success">
                        Réclamer
                    </b-button>
                </b-col>

            </b-row>

        </b-modal>

        <b-overlay :show="showLoading" spinner-variant="primary">
            <b-card>
                <div v-if="!showLoading && agGrid.rows.length === 0" class="text-center py-4">
                    <feather-icon icon="InboxIcon" size="48" class="text-muted mb-1" />
                    <h5 class="text-muted">Vous n'avez pas encore de réclamation</h5>
                    <p class="text-muted mb-2">Signalez un problème lié à votre commande, votre livraison ou autre.</p>
                    <b-button variant="success" @click="showModal">
                        <feather-icon icon="PlusCircleIcon" class="mr-50" /> Créer ma première réclamation
                    </b-button>
                </div>
                <ag-grid v-else :agGrid="agGrid" pageTitle="Liste des réclamations" @refresh="loadData">
                    <template #header-actions>
                        <b-button variant="success" size="sm" @click="showModal">
                            <feather-icon icon="PlusCircleIcon" class="mr-50" /> Nouvelle Réclamation
                        </b-button>
                    </template>
                </ag-grid>
            </b-card>
        </b-overlay>

    </div>
</template>

<script>

import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import BadgeCellRenderer from "@/views/components/ag-grid/BadgeCellRenderer.vue";

export default {

    metaInfo() {
        return {
            title: "Liste des réclamations - PharmaConnect",
            meta: [
                {
                    vmid: "description",
                    name: "description",
                    content:
                        "Consultez et gérez vos réclamations sur PharmaConnect. Suivez les statuts de vos réclamations et assurez une gestion efficace de vos demandes auprès des grossistes.",
                },
                {
                    name: "robots",
                    content: "index, follow",
                },
                {
                    property: "og:title",
                    content: "Liste des réclamations - PharmaConnect",
                },
                {
                    property: "og:description",
                    content: "Consultez et suivez l'état de vos réclamations sur PharmaConnect. Une solution simple et efficace pour la gestion des réclamations auprès des grossistes.",
                },
                {
                    property: "og:image",
                    content: "https://www.pharmaconnect.net/images/claims-thumbnail.jpg",
                },
                {
                    property: "og:url",
                    content: "https://www.pharmaconnect.net/claims",
                },
                {
                    property: "og:type",
                    content: "website",
                },
                {
                    name: "twitter:card",
                    content: "summary_large_image",
                },
                {
                    name: "twitter:title",
                    content: "Liste des réclamations - PharmaConnect",
                },
                {
                    name: "twitter:description",
                    content: "Consultez et suivez l'état de vos réclamations sur PharmaConnect. Une solution simple et efficace pour la gestion des réclamations auprès des grossistes.",
                },
                {
                    name: "twitter:image",
                    content: "https://www.pharmaconnect.net/images/claims-thumbnail.jpg",
                },
            ],
            link: [
                {
                    rel: "canonical",
                    href: "https://www.pharmaconnect.net/claims",
                },
            ],
            script: [
                // Structured Data using Schema.org
                {
                    type: "application/ld+json",
                    json: {
                        "@context": "https://schema.org",
                        "@type": "WebPage",
                        "name": "Liste des réclamations",
                        "description": "Consultez et gérez vos réclamations sur PharmaConnect. Suivez les statuts de vos réclamations et assurez une gestion efficace de vos demandes.",
                        "url": "https://www.pharmaconnect.net/claims"
                    },
                },
            ],
        };
    },

    components: {
        AgGrid,
    },
    data() {
        return {
            recText: '',
            selectedType: null,
            types: ['Contrôle', 'Prise de Commande', 'Livraison', 'Autre'],
            typeDescriptions: {
                'Contrôle': 'Qualité ou conformité produit',
                'Prise de Commande': 'Erreur lors de la saisie',
                'Livraison': 'Retard, manquant ou endommagé',
                'Autre': 'Toute autre demande',
            },
            showLoading: false,
            agGrid: {
                columnDefs: [
                    {
                        headerName: "Date",
                        field: "Date",
                        // width: 60
                    },
                    {
                        headerName: "Type",
                        field: "Complaint_Type",
                        // width: 80,
                    },
                    {
                        headerName: "Motif",
                        field: "Reason_Description",
                        // width: 80,
                    },
                    {
                        headerName: "Réclamation",
                        field: "Wording",
                        // width: 200
                    },
                    {
                        headerName: "Traité par",
                        field: "Treated_Name",
                        // width: 80,
                    },
                    {
                        headerName: "Statut",
                        field: "Statut",
                        cellClass: 'centered-customeCellRender',
                        cellRendererFramework: 'badgeCellRenderer',
                        cellRendererParams: { componentName: "Claims" },
                        width: 90
                    },
                ],
                rows: []
            },
        }
    },
    computed: {
        validateForm() {
            return this.selectedType != null && this.recText.trim() != '';
        },
    },
    created() {
        this.$options.components.badgeCellRenderer = BadgeCellRenderer;
        this.loadData();
    },
    methods: {
        reset_data() {
            this.recText = '';
            this.selectedType = null;
        },
        async envoyer() {
            this.$refs['my-modal'].hide();
            this.showLoading = !this.showLoading;

            // const currentDate = new Date();
            // const year = currentDate.getFullYear();
            // const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is 0-based
            // const day = String(currentDate.getDate()).padStart(2, '0');
            // const dateString = `${year}-${month}-${day}`;
            let inputs = {
                // "Date": dateString,
                "Complaint_Type": this.selectedType,
                "Wording": this.recText.substring(0, 400),
                "Web_Complaint": true
            }
            let response = await this.$http.post("claim", inputs).catch(() => {
                this.showLoading = false
            });
            if (response.status == 200) {
                this.recText = '';
                this.selectedType = null;
                this.$swal({
                    title: 'Réclamation envoyée avec succès .',
                    icon: 'success',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                    timer: 4000,
                    buttonsStyling: false,
                });
            }
            this.loadData();
        },
        showModal() {
            this.recText = '';
            this.selectedType = null;
            this.$refs['my-modal'].show();
            setTimeout(() => {
                this.$refs["description"].focus();
            }, 400);
        },
        async loadData() {
            this.showLoading = true;
            let response = await this.$http.get("claim").catch(() => {
                this.showLoading = false;
            });
            this.agGrid.rows = response.data.reverse();
            this.showLoading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
    .card {
        background-color: initial;
        box-shadow: initial;
    }

    .card-body {
        padding: 0px;
    }
}
</style>